// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inline-block[data-v-e1ac1ba6] {\n  display: inline-block;\n}\n.title-style[data-v-e1ac1ba6] {\n  line-height: 50px;\n}\n.loading-style[data-v-e1ac1ba6] {\n  width: 50px;\n  height: 20px;\n}\n.align-center[data-v-e1ac1ba6] {\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
